import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/pegasus/Documents/nobinpegasus.github.io/src/layouts/MDXLayout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`I have graduated from `}<strong parentName="p">{`Shahjalal University of Science and Technology`}</strong>{`, majoring in Computer Science and Engineering. Since my childhood, I have always been fascinated by this `}<strong parentName="p"><em parentName="strong">{`MAGIC BOX`}</em></strong>{` called computer. This magic box has always been a black box to me. I am still on a long journey to deciphering this black box.
I’ve also grown interest towards eBPF recently. You can check some of my eBPF works `}<a parentName="p" {...{
        "href": "https://github.com/NobinPegasus/xdp-tutorial/tree/nobin",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`here`}</a></p>
    <h4 {...{
      "id": "interests",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#interests",
        "aria-label": "interests permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Interests`}</h4>
    <p>{`Computer Architecture, Operating Systems, Systems Programming, Low Level Security, Psychology, eBPF`}</p>
    <hr></hr>
    <h4 {...{
      "id": "hobbies",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#hobbies",
        "aria-label": "hobbies permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hobbies`}</h4>
    <p>{`Outside of electronics world I love playing football, exploring new places, cycling on long rides, practising Karate and other dopamine inducing tasks. And when it’s neither computers nor thrill, I just love spending hours on end gossiping with my friends. `}</p>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      